import { z } from 'zod';
import { ROLES } from '../permissions.js';

export const username = z
  .string()
  .min(3)
  .max(32)
  .regex(/^[a-zA-Z0-9._-]+$/, 'letters, digits, dot, underscore, hyphen only');

// Length-based policy per current NIST guidance; no composition rules.
export const password = z.string().min(12).max(256);

export const totpCode = z.string().regex(/^\d{6}$/);
export const backupCode = z.string().regex(/^[A-Z2-7]{4}-[A-Z2-7]{4}-[A-Z2-7]{2}$/i);

export const loginBody = z.object({
  username: z.string().min(1).max(64),
  password: z.string().min(1).max(256),
});

export const twoFaVerifyBody = z.object({
  code: z.union([totpCode, backupCode]),
});

export const changePasswordBody = z.object({
  currentPassword: z.string().min(1).max(256),
  newPassword: password,
});

export const createUserBody = z.object({
  username,
  email: z.email(),
  displayName: z.string().min(1).max(80),
  password,
  role: z.enum(ROLES),
});

export const sessionUser = z.object({
  id: z.uuid(),
  username: z.string(),
  displayName: z.string(),
  email: z.string(),
  role: z.enum(ROLES),
  totpEnabled: z.boolean(),
  mfaPending: z.boolean(),
});
export type SessionUser = z.infer<typeof sessionUser>;
